import type { B2bSelectOption } from 'components/b2b/FieldSelect/FieldSelect';

/** Demo city list (contract `city` strings). Replace with API-backed options when available. */
export const B2B_REGISTRATION_DEMO_CITY_OPTIONS: readonly B2bSelectOption[] = [
  { value: 'baghdad', label: 'Baghdad' },
  { value: 'basra', label: 'Basra' },
  { value: 'erbil', label: 'Erbil' },
  { value: 'mosul', label: 'Mosul' },
  { value: 'najaf', label: 'Najaf' },
  { value: 'other', label: 'Other' },
] as const;
